module.exports = __webpack_public_path__ + "img/badge_color_ms-career.8362943a.svg";